// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.arrow {
  width: 15px;
  height: 15px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: transparent;
  cursor: pointer;
}

.arrow.left {
  left: 25px;
  border: solid black;
  border-width: 0 4px 4px 0;
  transform: rotate(135deg);
}

.arrow.right {
  right: 25px;
  border: solid black;
  border-width: 0 0 4px 4px;
  transform: rotate(-135deg);
}

.indicator {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
}

.bubble {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: gray;
  display: inline-block;
  margin: 0 5px;
  cursor: pointer;
}

.bubble.active {
  background-color: white;
}
`, "",{"version":3,"sources":["webpack://./src/pages/landingPage/banner/style.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".arrow {\n  width: 15px;\n  height: 15px;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  background-color: transparent;\n  cursor: pointer;\n}\n\n.arrow.left {\n  left: 25px;\n  border: solid black;\n  border-width: 0 4px 4px 0;\n  transform: rotate(135deg);\n}\n\n.arrow.right {\n  right: 25px;\n  border: solid black;\n  border-width: 0 0 4px 4px;\n  transform: rotate(-135deg);\n}\n\n.indicator {\n  position: absolute;\n  bottom: 10px;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.bubble {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background-color: gray;\n  display: inline-block;\n  margin: 0 5px;\n  cursor: pointer;\n}\n\n.bubble.active {\n  background-color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
